var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBroadcastArrowLineLeftWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.375H9.375v-5a.625.625 0 00-1.067-.443L2.683 9.557a.625.625 0 000 .885l5.625 5.625a.625.625 0 001.067-.443v-5H15a.625.625 0 100-1.25zM17.813 3.125v13.75a.624.624 0 11-1.25 0V3.125a.625.625 0 111.25 0z",
    fill: "#fff"
  })));
}

export default SvgBroadcastArrowLineLeftWhite;